import Permissions from '../../models/Permissions'
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './Dashboard.vue')
const ReportPP = () => import(/* webpackChunkName: "report" */ './ReportPP.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR,
  Permissions.USUARIO
]

const route = {
  path: 'dashboard',
  name: 'Questionário',
  component: Dashboard,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const report = {
  path: 'report/:cpf/:idQuestionario/:cpfCnpj',
  name: 'Perfil de Personalidade',
  component: ReportPP,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  route,
  report
}



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js